// extracted by mini-css-extract-plugin
export default {"loginWrapper":"VerifyUser_loginWrapper__p64xr","loginBlock":"VerifyUser_loginBlock__ka5o2"};